import type { ReactNode } from 'react';

export function EmptyState({
  title,
  hint,
  icon,
}: {
  title: string;
  hint?: string;
  icon?: ReactNode;
}) {
  return (
    <div className="rounded-lg border border-dashed border-border-subtle bg-surface-1/40 p-10 text-center">
      {icon ? <div className="text-text-subtle inline-flex mb-3">{icon}</div> : null}
      <div className="text-sm font-medium text-text-strong">{title}</div>
      {hint ? <div className="text-xs text-text-muted mt-1.5">{hint}</div> : null}
    </div>
  );
}
